import {defineType} from 'sanity'
import {FaQuoteLeft} from 'react-icons/fa'
import {ComponentPreview} from './ComponentPreview'

export default defineType({
  type: 'object',
  name: 'quote',
  title: 'Quote',
  icon: FaQuoteLeft,
  components: {
    preview: (props) => <ComponentPreview {...props} />,
  },
  preview: {
    select: {
      title: 'text',
      subtitle: 'author',
    },
  },
  fields: [
    {
      name: 'text',
      type: 'text',
      title: 'Text',
    },
    {
      name: 'author',
      type: 'string',
      title: 'Author',
    },
  ],
})
